module.exports = "//public.zight.com/packs/media/images/zendesk-dd7d619b3bc40416ff7b2786e50fa682.png";